<template>
  <div class="el-tree-new-normal">
    hahah 
    <el-tree-dict dictType="area"  :maxLevel="2"></el-tree-dict>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: [],
      defaultProps: {
        children: "children",
        label: "areaName"
      }
    }
  },
  created() {
    this.$getDictObjByDictTypes("area").then(data => {
      this.data = this.$listToTree(data["area"])
    })
  }
}
</script>

<style>

</style>